'use strict';

var iconv_package;
var Iconv;

try {
    // this is to fool browserify so it doesn't try (in vain) to install iconv.
    iconv_package = 'iconv';
    Iconv = require(iconv_package).Iconv;
} catch (E) {
    // node-iconv not present
}

module.exports = Iconv;



/*****************
 ** WEBPACK FOOTER
 ** ./~/encoding/lib/iconv-loader.js
 ** module id = 143
 ** module chunks = 0
 **/